<template>
    <BreadCrumb PageTitle="Rechargement compte préparé effectué avec succès" />
    <PrepaidRechargeSuccess/>
  </template>
  
  <script lang="ts">
    import { defineComponent } from "vue";
  
    import BreadCrumb from "../../components/Common/BreadCrumb.vue";
    import PrepaidRechargeSuccess from "@/components/Compte/PrepaidRechargeSuccess.vue";
  
    export default defineComponent({
      name: "PrepaidRechargeSuccessPage",
      components: {
        BreadCrumb,
        PrepaidRechargeSuccess,
      },
    });
  </script>